import React from 'react';
import MobileRoutes from './routes/MobileRoutes';

export default function MobileApp() {
  return <MobileRoutes />;
}
